// app/lib/tracking/tiktok.ts

export const ttqEvent = (
  eventName: string,
  params: Record<string, unknown> = {},
): void => {
  if (typeof window === "undefined" || !window.ttq) return;
  window.ttq.track(eventName, params);
};
